export const LocationUtil = {
  reload: () => {
    window.location.reload();
  },
};

if (IS_RUNNING_IN_CYPRESS === 'true') {
  // @ts-ignore
  window.PARADEX__LocationUtil = LocationUtil;
}
